<template>
  <div
    class="ltk-date-picker flex custom-select"
    :class="[orientation, { disabled: disabled || loading }]"
    ref="ltkDatePicker"
  >
    <label v-if="label">{{ label }}</label>

    <form class="select-trigger" @click="toggleCalendar()">
      <div class="input flex middle between" :class="{ active: showCalendar }">
        <div v-if="activeData && activeData.start && activeData.end">
          {{ activeData.start.format("DD/MM/YY") }} a
          {{ activeData.end.format("DD/MM/YY") }}
        </div>
        <i class="far fa-calendar-alt">
          <!-- <span class="tooltipboxtext">Selecione um período</span> -->
        </i>
      </div>
    </form>

    <div class="calendar grid-flex stretch between" v-show="showCalendar">
      <!-- Pra q isso @renao? -->
      <!-- :style="{ top: ltkDatePickerTop + 'px' }" -->

      <!-- Periods sidebar -->
      <div v-if="!disabledPeriods" class="calendar-sidebar periods">
        <ul>
          <li
            :class="{
              active: selectPeriodIs('active', period.id),
              disabled: selectPeriodIs('disabled', period.id),
            }"
            @click="selectPeriod(period.id)"
            v-for="period in periods"
            :key="period.id"
          >
            {{ period.name }}
          </li>
        </ul>
        <div class="actions flex end middle show-action-left">
          <span @click="cancel()">
            <div class="button secondary">Cancelar</div>
          </span>

          <span @click="apply()">
            <div class="button primary">Aplicar</div>
          </span>
        </div>
      </div>

      <!-- Months -->
      <div
        class="calendar-content grid-flex between column"
        :class="{ disabledPeriods: disabledPeriods }"
      >
        <div class="months grid-flex between row">
          <div class="month month1 flex-1">
            <div class="head grid-flex middle start">
              <span
                @click="changeMonth(-1)"
                class="icon prev flex middle center"
              >
                <i class="fas fa-angle-left"></i>
              </span>
              <span class="name" v-if="month1 && month1.mom">
                <span class="captalize">{{ month1.mom.format("MMMM") }}</span>
                de
                {{ month1.mom.format("YYYY") }}
              </span>
            </div>
            <div class="days">
              <div class="days-head">
                <div class="day-item" v-for="name in weekHead" :key="name">
                  {{ name }}
                </div>
              </div>
              <div class="days-week">
                <div
                  :class="{
                    start: dateIs('start', day.date),
                    between: dateIs('between', day.date),
                    end: dateIs('end', day.date),
                    disabled: dateIs('disabled', day.date),
                    empty: dateIs('empty', day.date),
                  }"
                  class="day-item"
                  v-for="(day, index) in month1.days"
                  :key="index"
                  @click="clickDate(day.date)"
                >
                  <div class="day-box" v-if="!day.empty">
                    {{ day.date.format("DD") }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="month month2 flex-1">
            <div class="head grid-flex middle end">
              <span class="name" v-if="month2 && month2.mom">
                <span class="captalize">{{ month2.mom.format("MMMM") }}</span>
                de
                {{ month2.mom.format("YYYY") }}
              </span>
              <span
                @click="changeMonth(1)"
                class="icon next flex middle center"
              >
                <i class="fas fa-angle-right"></i>
              </span>
            </div>
            <div class="days">
              <div class="days-head">
                <div class="day-item" v-for="name in weekHead" :key="name">
                  {{ name }}
                </div>
              </div>
              <div class="days-week">
                <div
                  :class="{
                    start: dateIs('start', day.date),
                    between: dateIs('between', day.date),
                    end: dateIs('end', day.date),
                    disabled: dateIs('disabled', day.date),
                    empty: dateIs('empty', day.date),
                  }"
                  class="day-item"
                  v-for="(day, index) in month2.days"
                  :key="index"
                  @click="clickDate(day.date)"
                >
                  <div class="day-box" v-if="!day.empty">
                    {{ day.date.format("DD") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="actions flex end middle">
          <!-- @renao ajuda aqui -->
          <span @click="cancel()">
            <div class="button secondary">Cancelar</div>
          </span>

          <span @click="apply()">
            <div class="button primary">Aplicar</div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ltkButton from "@/designsystem/buttons/ltkButton";
import moment from "moment";
moment.locale("pt-br");

export default {
  name: "ltk-date-picker",
  components: {},
  props: [
    "value",
    "dateRangeLimit",
    "disabledPeriods",
    "disabled",
    "quantityToDays",
    "orientation",
    "startDate",
    "label",
    "loading",
  ],
  data() {
    return {
      showCalendar: false,
      selectedName: "",
      periodId: null,
      ltkDatePickerTop: 0,
      activeData: {
        start: null,
        end: null,
        periodId: null,
      },
      periods: [
        {
          id: 1,
          name: "Vitalício",
        },
        {
          id: 2,
          name: "Hoje",
        },
        {
          id: 3,
          name: "Ontem",
        },
        {
          id: 4,
          name: "Últimos 7 dias",
        },
        {
          id: 5,
          name: "Últimos 14 dias",
        },
        {
          id: 6,
          name: "Últimos 30 dias",
        },
      ],
      weekHead: ["Seg", "Ter", "Qua", "Qui", "Sex", "Sab", "Dom"],
      start: null,
      end: null,
      month1: {
        mom: null,
        days: [],
      },
      month2: {
        mom: null,
        days: [],
      },
    };
  },
  mounted() {
    this.start = this.activeData.start = moment(this.value[0]).startOf("day");
    this.end = this.activeData.end = moment(this.value[1]).startOf("day");

    this.initMonthsDate();
  },
  created() {
    let self = this;
    window.addEventListener("click", function(e) {
      // close dropdown when clicked outside
      if (!self.$el.contains(e.target)) {
        self.showCalendar = false;
      }
    });
  },
  watch: {
    value: {
      handler() {
        this.start = this.activeData.start = moment(this.value[0]).startOf(
          "day"
        );
        this.end = this.activeData.end = moment(this.value[1]).startOf("day");
        this.validateDateRangeLimit();
      },
      deep: true,
    },
    startDate() {
      this.initMonthsDate();
    },
    dateRangeLimit() {
      this.validateDateRangeLimit();
    },
  },
  methods: {
    initMonthsDate() {
      this.setMonthsDate();
      this.populateMonths();
    },
    validateDateRangeLimit() {
      if (
        !this.dateRangeLimit ||
        (this.dateRangeLimit && this.dateRangeLimit.length < 2)
      ) {
        return;
      }
      if (this.start.toDate() < this.dateRangeLimit[0]) {
        this.start = this.activeData.start = moment(
          this.dateRangeLimit[0]
        ).startOf("day");
      }
      if (this.end.toDate() > this.dateRangeLimit[1]) {
        this.end = this.activeData.end = moment(this.dateRangeLimit[1]).startOf(
          "day"
        );
      }
    },
    setMonthsDate() {
      if (this.startDate) {
        this.month1.mom = moment(this.startDate)
          .startOf("day")
          .startOf("month")
          .add(-1, "M");

        this.month2.mom = moment(this.startDate)
          .startOf("day")
          .startOf("month");

        return;
      }
      this.month1.mom = moment()
        .startOf("day")
        .startOf("month")
        .add(-1, "M");

      this.month2.mom = moment()
        .startOf("day")
        .startOf("month");
    },
    toggleCalendar() {
      if (this.disabled || this.loading) return;
      this.showCalendar = !this.showCalendar;
      this.calcLtkDatePickerHeight();
    },
    populateMonths() {
      this.month1.days = this.mountMonth(this.month1.mom);
      this.month2.days = this.mountMonth(this.month2.mom);
    },
    changeMonth(increment) {
      this.month1.mom = this.month1.mom.add(increment, "M");
      this.month2.mom = this.month2.mom.add(increment, "M");
      this.populateMonths();
    },
    clickDate(date) {
      if (this.dateIs("disabled", date)) return false;
      this.periodId = null;

      if (this.start && this.end) {
        this.start = this.end = null;
      }

      if (!this.start) this.start = date;
      else if (!this.end) {
        this.end = date;
        if (this.start > this.end) {
          this.end = this.start;
          this.start = date;
        }
      }
    },
    dateIs(_type, date) {
      if (_type == "empty" && !date) return true;
      if (!date) return false;

      if (_type == "start") {
        if (
          this.start &&
          this.start.format("DD/MM/YY") == date.format("DD/MM/YY")
        )
          return true;
        return false;
      } else if (_type == "between") {
        if (this.start && this.end && this.start < date && date < this.end)
          return true;
        return false;
      } else if (_type == "end") {
        if (this.end && this.end.format("DD/MM/YY") == date.format("DD/MM/YY"))
          return true;
        return false;
      } else if (_type == "disabled") {
        if (!this.dateRangeLimit) return false;
        if (date < this.dateRangeLimit[0] || date > this.dateRangeLimit[1])
          return true;
        return false;
      }
      return false;
    },
    selectPeriodIs(_type, periodId) {
      if (_type == "active") {
        return periodId == this.periodId ? true : false;
      }
      if (_type == "disabled") {
        if (!this.dateRangeLimit) return false;
        let period = this.getPeriodRange(periodId);
        if (
          period[0].toDate() < this.dateRangeLimit[0] ||
          period[1].toDate() > this.dateRangeLimit[1]
        )
          return true;
        return false;
      }
      return false;
    },
    selectPeriod(periodId) {
      if (this.selectPeriodIs("disabled", periodId)) return;
      this.periodId = periodId;
      let period = this.getPeriodRange(periodId);
      this.start = period[0];
      this.end = period[1];
    },
    getPeriodRange(periodId) {
      let start = null;
      let end = moment()
        .startOf("day")
        .add(-1, "d");

      if (periodId == 1) {
        if (this.dateRangeLimit) {
          start = moment(this.dateRangeLimit[0]).startOf("day");
          end = moment(this.dateRangeLimit[1]).startOf("day");
        } else start = moment("01/01/2021", "DD/MM/YYYY");
      } else if (periodId == 2) {
        start = end = moment().startOf("day");
      } else if (periodId == 3) {
        start = end;
      } else if (periodId == 4) {
        start = moment(end).add(-7, "d");
      } else if (periodId == 5) {
        start = moment(end).add(-14, "d");
      } else if (periodId == 6) {
        start = moment(end).add(-30, "d");
      }

      return [start, end];
    },
    cancel() {
      this.periodId = this.activeData.periodId;
      this.start = this.activeData.start;
      this.end = this.activeData.end;
      this.showCalendar = false;
    },
    apply() {
      if (!this.start && !this.end) return;

      let auxStart = this.start || this.end
      let auxEnd = this.end || this.start

      this.activeData = {
        start: auxStart,
        end: auxEnd,
        periodId: this.periodId,
      };
      this.showCalendar = false;
      this.$emit("input", [
        new Date(this.activeData.start.format("MM/DD/YYYY")),
        new Date(this.activeData.end.format("MM/DD/YYYY")),
      ]);
      this.$emit("change", true);
    },
    mountMonth(mMonth) {
      let dateBase = moment(mMonth).startOf("day");
      let result = [];
      let weekDay = 1; // 1 = Segunda .... 6 = Sabado e 0 = Domingo
      let monthBase = dateBase.format("MM");

      while (dateBase.format("MM") == monthBase) {
        if (dateBase.format("d") != weekDay) {
          result.push({
            empty: true,
          });
          weekDay += 1;
          if (weekDay == 7) weekDay = 0;
          continue;
        }

        result.push({
          empty: false,
          date: moment(dateBase).startOf("day"),
          value: 0,
        });

        weekDay += 1;
        if (weekDay == 7) weekDay = 0;

        dateBase = dateBase.add(1, "d");
      }

      return result;
    },
    calcLtkDatePickerHeight() {
      if (window.innerWidth > 980) {
        this.ltkDatePickerTop = 0;
        return;
      }
      let calendar = this.$refs.ltkDatePicker;
      this.ltkDatePickerTop =
        window.pageYOffset + calendar.getBoundingClientRect().top;
    },
  },
};
</script>

<style lang="scss" scoped>
.ltk-date-picker {
  position: relative;
  flex: 1;
  user-select: none;
  display: inline-block;
  min-width: 200px;
  max-width: 250px;

  .select-trigger {
    background: white;
  }

  &.disabled {
    opacity: 0.5;
    filter: blur(1px);
    &,
    .input {
      cursor: not-allowed !important;
    }
  }

  form {
    width: 100%;
    .fa-calendar-alt {
      font-size: 2rem;
      color: var(--color-grey-3);
    }
    .input {
      cursor: pointer;
      &.active {
        border-color: var(--color-brand-purple);
      }
      &:not(.active):hover {
        border-color: var(--color-grey-3);
      }
    }
  }

  &.left .calendar {
    left: 0;
    right: auto;
  }

  .calendar {
    position: absolute;
    right: 0;
    width: 80vw;
    max-width: 740px;
    min-width: 640px;
    background: var(--color-white);
    z-index: 99999;
    // min-height: 335px;
    margin-top: 8px;
    // border: 1px solid var(--color-grey-0);

    color: var(--color-grey-6);
    border-radius: var(--border-radius-s);
    box-shadow: var(--drop-shadow-16);

    .calendar-sidebar {
      padding-top: var(--spacing-2-xl);
      line-height: var(--text-p-line-height);
      border-right: var(--border-grey-1);
      min-width: 136px;

      ul {
        li {
          display: block;
          padding: var(--spacing-s) var(--spacing-l);
          white-space: nowrap;

          &:hover:not(.disabled) {
            background: var(--color-grey-0);
          }

          &.active {
            background: var(--color-grey-1);
            // background: var(--color-purple-0);
            color: var(--color-purple-5);
            // font-weight: 500;
          }

          &.disabled {
            color: var(--color-grey-2);
          }

          &:not(.active):not(.disabled) {
            cursor: pointer;
          }
        }
      }
    }

    .months {
      padding: 0 4px;

      .month {
        padding: var(--spacing-l);
        width: 50%;

        &:last-child {
          border-left: var(--border-grey-1);
          padding-left: var(--spacing-xl);
        }

        &:first-child {
          padding-right: var(--spacing-xl);
        }

        .head {
          margin-bottom: var(--spacing-s);
          --icon-size: 28px;

          .icon {
            cursor: pointer;
            font-size: 14px;
            width: var(--icon-size);
            height: var(--icon-size);
            flex-shrink: 0;
            border-radius: var(--border-radius-xs);

            &:hover {
              background: var(--color-grey-1);
            }

            + .name {
              padding-right: var(--icon-size);
            }
          }

          .name {
            text-align: center;
            width: 100%;
            font-weight: var(--text-font-weight-medium);
            color: var(--color-brand-black);
            span {
              text-transform: capitalize;
            }
            &:first-child {
              padding-left: var(--icon-size);
            }
          }
        }
      }

      .days {
        .days-head {
          display: flex;
          color: var(--color-grey-4);
          font-size: var(--text-s12-font-size);
          margin-bottom: var(--spacing-xs);
          .day-item {
            width: calc(100% / 7);
            text-align: center;
            padding: var(--spacing-xs) 0;
          }
        }

        .days-week {
          display: flex;
          flex-wrap: wrap;
          font-size: var(--text-p14-font-size);

          .day-item {
            width: calc(100% / 7);
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 8px;
            height: 36px;
            margin-bottom: 2px;
            cursor: pointer;

            &:hover {
              &:not(.start):not(.end):not(.disabled):not(.empty) {
                background: var(--color-grey-0);
                color: var(--color-brand-black);
              }
            }

            &.start {
              background: var(--color-brand-purple);
              border-radius: 4px 0 0 4px;
              color: white;
            }

            &.between {
              background: var(--color-grey-1);
              // background: var(--color-purple-0);
              color: var(--color-purple-6);
            }

            &.end {
              background: var(--color-brand-purple);
              border-radius: 0 4px 4px 0 !important;
              color: white;
            }

            &.disabled {
              color: var(--color-grey-2);
              cursor: unset;
            }

            &.start.end {
              // border-radius: 50%;
              border-radius: 4px;
              background: var(--color-purple-5);
            }

            &:nth-child(7n + 7).between {
              border-radius: 0 4px 4px 0;
            }
            &:nth-child(7n + 1).between {
              border-radius: 4px 0 0 4px;
            }
          }
        }
      }
    }

    // Action buttons
    .actions {
      width: 100%;
      border-top: var(--border-grey-1);
      padding: var(--spacing-m) var(--spacing-2-xl);
      gap: var(--spacing-m);
    }
  }
}

//Resposive
.show-action-left {
  display: none;
}

@media only screen and (max-width: 980px) {
  .filters {
    flex-direction: column;
  }

  .show-action-left {
    display: inline;
    button {
      width: 90%;
      text-align: center;
      margin-top: 8px;
      margin-left: 8px;
      z-index: 100;
      position: relative;
    }
  }

  .ltk-date-picker .calendar {
    width: 100vw;
    height: 100vh;
    left: 0;
    position: fixed;
    min-height: auto;
    margin-top: 0;
    top: 0;

    .actions {
      padding: 20px 0px !important;

      .button {
        width: 100%;
      }
    }

    .months {
      margin-top: 0;
      top: 0;
      position: relative;
      height: fit-content;
    }
  }
  .grid-flex .row {
    flex-direction: column;
  }
}

@media screen and (max-width: 1024px) {
  .ltk-date-picker {
    width: 100%;
    margin-top: 5px;
  }
}
</style>
